/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Timer_ExtensionsInputs */



/**
* | output |
* | --- |
* | "- **+1 / +2 / +5 / +10 minutes** — extra time for that table alone, up to **30 minutes** in total. The table shows how much it has been granted, and its own ..." |
*
* @param {Og_Timer_ExtensionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_timer_extensions = /** @type {((inputs?: Og_Timer_ExtensionsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Timer_ExtensionsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("- **+1 / +2 / +5 / +10 minutes** — temps supplémentaire pour cette seule table, jusqu'à **30 minutes** au total. La table affiche combien de temps lui a été accordé, et son propre compte à rebours en tient compte.")
	if (locale === "es") return /** @type {LocalizedString} */ ("- **+1 / +2 / +5 / +10 minutos** — tiempo extra solo para esa mesa, hasta un máximo de **30 minutos** en total. La mesa muestra cuánto se le ha concedido, y su propia cuenta atrás lo refleja.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("- **+1 / +2 / +5 / +10 minutos** — tempo extra só para aquela mesa, até **30 minutos** no total. A mesa mostra quanto tempo já recebeu, e sua própria contagem regressiva reflete isso.")
	if (locale === "it") return /** @type {LocalizedString} */ ("- **+1 / +2 / +5 / +10 minuti** — tempo extra per quel solo tavolo, fino a **30 minuti** totali. Il tavolo mostra quanto tempo gli è stato concesso, e il suo conto alla rovescia lo riflette.")
	return /** @type {LocalizedString} */ ("- **+1 / +2 / +5 / +10 minutes** — extra time for that table alone, up to **30 minutes** in total. The table shows how much it has been granted, and its own countdown reflects it.")
});